import { Grid, IconButton, Tooltip, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import MUIDataTable from "mui-datatables";
import PDialog from "../../../../components/pos/PDialog";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import PFileDropZone from "../../../../components/pos/PFileDropZone";
import PFileViewer from "../../../../components/pos/PFileViewer";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import API from "../../../../utils/API";
import db from "../../../../db/db";

export default function DocumentUploadListView(props) {

  const [openFileDropWindow, setOpenFileDropWindow] = useState(false);
  const [openFileViewWindow, setOpenFileViewWindow] = useState(false);
  const [previewFileList, setPreviewFileList] = useState([]);
  
  const [fileCategoryOptons, setFileCategoryOptions] = useState([
    { name: "CERTIFICATE", id: "CERTIFICATE" },
    { name: "PRODUCT IMAGE", id: "PRODUCT_IMAGE" },
  ]);

  const { t } = useTranslation();
  const translate = t;

  function handleFileSave(selectedFiles) {
    saveFiles(selectedFiles);
  }

  function handleAddFileClick() {
    setOpenFileDropWindow(true);
  }

  
  function onRemoveItemClicked(tableMeta, updateValue, value) {
    let tempFileList = [...props.filesList];
    let updatedList = [];
    let index = 0;
    for (let i = 0; i < tempFileList.length; i++) {
      if (tableMeta.rowIndex != i) {
        tempFileList[i].index = index;
        updatedList.push(tempFileList[i]);
        index++;
      }
    }
    props.setFilesList(updatedList);
  }

  async function onFileViewClicked(tableMeta, updateValue, value) {
    let tempPreviewFileList = [];
    for (let i = 0; i < props.filesList.length; i++) {
      let fileItem = props.filesList[i];
      console.log("testzzz",fileItem.fileId);
      let fileData = fileItem.fileData;
      if (!fileData) {
        let dbData = await db.file
          .where("id")
          .equals(fileItem.fileId)
          .toArray();
        if (dbData[0] != null && dbData[0] != undefined) {
          fileData = dbData[0].fileData;
        }
      }
      let item = {
        selected:
          tableMeta.rowIndex == fileItem.serialNumber - 1 ? true : false,
        previewObj: fileData,
        fileType: fileItem.fileType,
      };
      tempPreviewFileList.push(item);
    }
    setPreviewFileList(tempPreviewFileList);
    setOpenFileViewWindow(true);
  }

  async function saveFiles(selectedFiles) {
    let promises = [];
    selectedFiles.map((fileItem) => {
      promises.push(
        new Promise((resolve, reject) => {
          let saveObject = Object.create(null);

          let fileNameWithExt = fileItem.fileName;
          if (!fileNameWithExt.includes(fileItem.fileExtension)) {
            fileNameWithExt += "." + fileItem.fileExtension;
          }

          saveObject["fileType"] = fileItem.fileType; /*IMAGE or DOCUMENT*/
          saveObject["fileSize"] = fileItem.file.size; /*In bytes*/
          saveObject["fileName"] = fileNameWithExt;
          saveObject["fileTypeText"] =
            fileItem.fileTypeText; /*etc.. image/png*/
          saveObject["fileData"] = fileItem.previewObj; /*Base64 Object*/
          try {
            let response = API.post("/api/v1/file", saveObject);
            response.then((result) => {
              resolve(result.data);
            });
          } catch (err) {
            console.log("ERROR", err);
            resolve(null);
          }
        })
      );
    });

    Promise.all(promises).then((content) => {
      let tempFileList = [...props.filesList];
      content.map((savedObject) => {
        if (savedObject) {
          let fileSizeText = null;
          if ((savedObject.fileSize / 1024).toFixed(2) > 1000)
            fileSizeText =
              (savedObject.fileSize / (1024 * 1024)).toFixed(2) + " MB";
          else fileSizeText = (savedObject.fileSize / 1024).toFixed(2) + " KB";
          tempFileList.push({
            serialNumber: tempFileList.length + 1,
            fileId: savedObject.id,
            fileCategorySelected: null,
            fileCategoryId: null,
            fileCategoryName: null,
            fileName: savedObject.fileName,
            fileSize: savedObject.fileSize,
            fileSizeText: fileSizeText,
            fileType: savedObject.fileType,
            fileData: savedObject.fileData,
          });
        }
      });
      for(let i=0;i<=tempFileList;i++){
        console.log("tempFileListzzzz",tempFileList);
      }
      props.setFilesList(tempFileList);
    });
  }

  function onCloseWindow(){
    props.setshowDocumentUploadWindow(false)
  }
  const columns = [
    {
      name: "serialNumber",
      label: translate("SN"),
      options: {
        filter: false,
        sort: false,
        display: "true",
      },
    },
    {
      name: "fileName",
      label: translate("File Name"),
      options: {
        filter: false,
        sort: false,
        display: "true",
      },
    },
    {
      name: "fileSizeText",
      label: translate("File Size"),
      options: {
        filter: false,
        sort: false,
        display: "true",
      },
    },
    {
      name: "fileType",
      label: translate("File Type"),
      options: {
        filter: false,
        sort: false,
        display: "true",
      },
    },
    {
      name: "action",
      label: translate("Action"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customHeadLabelRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              <table width="100%">
                <tr>
                  <td align="right">Action</td>
                  <td align="right">
                    <Tooltip title={"Add File"}>
                      <IconButton
                        color="secondary"
                        onClick={handleAddFileClick}
                      >
                        <AddIcon />
                      </IconButton>
                    </Tooltip>
                  </td>
                </tr>
              </table>
            </div>
          );
        },
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ textAlign: "center" }}>
            <Tooltip
              title={translate("View File")}
              style={{ marginRight: "10px" }}
            >
              <IconButton
                color="primary"
                onClick={() => onFileViewClicked(tableMeta, updateValue, value)}
              >
                <OpenInNewOutlinedIcon />
              </IconButton>
            </Tooltip>

            <Button
              onClick={() => onRemoveItemClicked(tableMeta, updateValue, value)}
              color="secondary"
              style={{
                margin: 0,
                padding: 0,
                height: 17,
                width: 100,
                alignText: "right",
              }}
            >
              {translate("REMOVE FILE")}
            </Button>
          </div>
        ),
      },
    },
  ];
  const options = {
    filterType: null,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    pagination: false,
    selectableRows: "false",
    selectableRowsHeader: true,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "560px",
    tableBodyHeight: 560,
  };
    const content=(
        <div>
        <Grid item xs={12}>
          <MUIDataTable
            columns={columns}
            options={options}
            data={props.filesList}
          ></MUIDataTable>
        </Grid>
        </div>
    )
  return (
  <div>
    <PDialog
      content={content}
      showCrud={true}
      title={"Document Upload"}
      maxWidth={"lg"}
      fullWidth={true}
      open={true}
      hideSave={true}
      onCloseWindow={onCloseWindow}
    ></PDialog>
    <PFileDropZone
      handleFileSave={handleFileSave}
      openWindow={openFileDropWindow}
      setOpenWindow={setOpenFileDropWindow}
      showMessage={props.showMessage}
      maxSize={1}
    ></PFileDropZone>
    <PFileViewer
      openWindow={openFileViewWindow}
      setOpenWindow={setOpenFileViewWindow}
      showMessage={props.showMessage}
      filesList={previewFileList}
    ></PFileViewer>
  </div>
  )
}
